<template>
  <RouterView />
  <!-- PrimeVue Toast and ConfirmDialog components -->
  <Toast />
  <ConfirmDialog />
</template>

<script setup>
import { RouterView } from 'vue-router'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
</script>

